import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IStorageType } from '../interfaces/storage-type';
import { IStorageTypeFilter } from '../interfaces/storage-type-filter';
import { EditService } from './edit.service';
import { HttpResponsesHandlersFactory } from '../handlers/http-responses-handler';

@Injectable({ providedIn: 'root' })
export class StorageTypeService extends EditService<IStorageType, IStorageTypeFilter> {
  url = '/api/storagetypes';
  entityTitle = 'StorageType';

  constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
    super(http, handlersFactory);
  }
}
